import { Storage } from '@material-ui/icons';

import useAssetThumbnail from './useAssetThumbnail';
import ImageAvatar from '../common/ImageAvatar';

const AssetAvatar = ({ asset, className, size = 80 }) => {
    const blobURL = useAssetThumbnail(asset.displayImageId, size);

    return (
        <ImageAvatar alt={asset.name} src={blobURL} className={className}>
            <Storage fontSize='inherit' color='action' />
        </ImageAvatar>
    );
};

export default AssetAvatar;
